import { memo } from "react";
import LoginBox from "./LoginComponents/LoginBox";
import LoginCard from "./LoginComponents/MainBox/LoginCard";
import LeftInformation from "../LeftInformation/LeftInformation";

function LoginForm({ flipCard, seeLogin, setOpenResetDialog }) {
  return (
    <LoginBox
      style={{
        overflow: "hidden",
      }}
    >
      <LeftInformation
        flipCard={flipCard}
        loginPage={seeLogin}
        setOpenResetDialog={setOpenResetDialog}
      />
      <LoginCard />
    </LoginBox>
  );
}

export default memo(LoginForm);
